module.exports = __webpack_public_path__ + "img/o2o-logo.1b76b5e5.svg";